<template>
    <div class="container">
        <div class="container py-3">
            <div class="breadcrumbs-retos mb-3">
                <a href="/home-bat">
                    <img src="/img/icons/homeBread.svg" alt="" />
                    Home /
                </a>
                <span class="color-active-miga"><strong>Pasarela</strong></span>
            </div>
            <a class="my-3" href="/catalogo" @click="returnBack()"><img src="/img/icons/regresar.svg" alt="icon"></a>
        </div>
        <div class="header-catalog pt-4">
            <h5>Carrito de compras</h5>
        </div>
        <div class="my-3">
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-4 col-md-2 d-flex flex-column justify-content-center align-items-center">
                    <img src="/img/icons/cart_green.svg" alt="cart">
                    <span class="mt-2 text-center text-title-bat text-green-cart">
                        Confirmación
                    </span>
                </div>
                <div class="col-3 col-md-1 aling-items-center">
                    <div :class="step === 1 ? 'border border-1 border-secondary border-opacity-50' : 'border-green-cart'">
                    </div>
                </div>
                <div class="col-4 col-md-2 d-flex flex-column justify-content-center align-items-center">
                    <img v-if="step === 1" src="/img/icons/data_grey.svg" alt="data">
                    <img v-else src="/img/icons/data_green.svg" alt="data">
                    <span class="mt-2 lh-1 text-center" :class="step === 1 ? 'text-bat text-secondary text-opacity-75' : 'text-title-bat text-green-cart '">
                        Datos personales
                    </span>
                </div>
            </div>
        </div>

        <div class="container-fluid py-5">
            <div class="row justify-content-between">
                <div class="col-12 col-md-12 col-lg-6 text-bat">
                    <div v-if="step === 1" class="col-12 col-md-9 mx-auto mb-2 pb-2">
                        <div v-for="(product, index) in local_products" class="mx-auto bg-white shadow-sm mb-2 mb-md-4 px-3 py-2 rounded-4">
                            <div class="row d-flex justify-content-between mb-2">
                                <div class="col-4 col-6">
                                    <span class="px-2 py-1 bg-info bg-opacity-10 fs-7 fw-semibold rounded">
                                        {{ product.CATEGORY }}
                                    </span>
                                </div>
                                <div class="col-4">
                                    <div class="float-end cursor-pointer" @click="delete_product_guid = product.GUID; modal_delete_product = true">
                                        <img class="w-75" src="/img-version2/icons/trash.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-8">
                                    <p class="text-title-bat fs-4 mb-0">
                                        {{ (product.POINTS_UNIT_VALUE + product.POINTS_UNIT_SHIPPING) * product.QUANTITY }}
                                        <span class="fs-7 text-bat">
                                            Puntos
                                        </span>
                                    </p>
                                    <span class="text-secondary mb-2">
                                        {{ product.INVENTORY }} unds disponibles
                                    </span>
                                    <h6 class="text-bat text-indigo-darkness fw-bold mb-2">
                                        {{ product.NAME }}
                                    </h6>
                                    <p v-if="product.PRODUCT_TYPE_ID == 12 || product.PRODUCT_TYPE_ID == 13" style="font-size: 12px">Solo puedes redimir un producto de este tipo</p>
                                    <div class="col-5">
                                        <div v-if="product.PRODUCT_TYPE_ID == 12 || product.PRODUCT_TYPE_ID == 13" class="row">
                                            <div class="col-4 d-flex justify-content-center">
                                                <p class="bg-secondary bg-opacity-10 text-center px-3 py-1 rounded">
                                                    <strong>
                                                        {{ product.QUANTITY }}
                                                    </strong>
                                                </p>
                                            </div>

                                        </div>
                                        <div v-else class="row">
                                            <div class="col-4 d-flex justify-content-center h-100">
                                                <button class="border-0 bg-transparent" @click="changeQuantity(index, 'remove')">
                                                    <img src="/img/icons/cantidad-flecha-abajo.svg" alt="">
                                                </button>
                                            </div>
                                            <div class="col-4 d-flex justify-content-center">
                                                <p class="bg-secondary bg-opacity-10 text-center px-3 py-1 rounded">
                                                    <strong>
                                                        {{ product.QUANTITY }}
                                                    </strong>
                                                </p>
                                            </div>
                                            <div class="col-4 col-4 d-flex justify-content-center h-100">
                                                <button class="border-0 bg-transparent" @click="changeQuantity(index, 'add')">
                                                    <img src="/img/icons/cantidad-flecha-arriba.svg" alt="">
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="justify-content-center mx-auto text-center">
                                        <img class="img-fluid" :src="url_media + (product.PRODUCT_IMAGE !== null ? product.PRODUCT_IMAGE.replace('~/', '') : 'image.png')" :alt="product.NAME">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="personal_data && personal_data.length>0" class="row mb-4">
                            <div class="col-md-8 mb-3 mb-md-0">
                                <a @click="addDeliveryData" class="wrapper-add-delivery mb-3 shadow p-2 h-100" :class="personal_data.length >= 3 ? 'disabled-add' : ''">
                                    <!-- <p><i class="fa fa-plus" aria-hidden="true"></i></p> -->
                                    <p>
                                        Agregar información de entrega
                                        <i class="ms-2 fa fa-plus" aria-hidden="true"></i>
                                    </p>
                                </a>
                            </div>
                            <div class="my-4">
                                <h6 class="mb-0">
                                    Cuentas de envió registrada
                                </h6>
                            </div>
                            <div v-for="(item, index) in personal_data" class="col-md-6">
                                <div class="wrapper-delivery mb-3 position-relative shadow" :class="item.is_default_option == 1 ? 'active' : 'inactive'">
                                    <div v-if="item.is_default_option == 1" class="car-container">
                                        <img src="/img-version2/icons/delivery-1.svg" alt="delivery">
                                    </div>
                                    <div @click="changeDeliveryData(item.id)" class="box box1">
                                        <div class="start">
                                            <img v-if="item.is_default_option == 1" src="/img-version2/icons/arrow-right.svg" alt="arrow-right">
                                            <img v-if="item.is_default_option == 0" src="/img-version2/icons/arrow-right-secondary.svg" alt="arrow-right-secondary">
                                        </div>
                                        <div class="preliminary-information">
                                            <p class="address text-truncate w-100">{{ item.address }}</p>
                                            <p class="email text-truncate w-100">{{ item.email }}</p>
                                            <p class="mobile-number">{{ formatMobileNumber(item.mobile_number) }}</p>
                                        </div>
                                    </div>
                                    <div class="box box2">
                                        <a class="edit-delivery-data" @click="editDeliveryData(item, index)"><img src="/img-version2/icons/edit-2.svg" alt="edit-2"></a>

                                        <a v-if="personal_data && personal_data.length > 1 && personal_data_default && item.id == personal_data_default.id" class="default-delivery-data"><img src="/img-version2/icons/tick-circle.svg" alt="trash"></a>
                                        <a v-else class="delete-delivery-data" @click="deleteDeliveryData(item, index)"><img src="/img-version2/icons/trash.svg" alt="trash"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div class="col-12 mb-3 mb-md-0">
                                <a @click="addDeliveryData" class="wrapper-add-delivery mb-3 shadow p-2">
                                    <!-- <p><i class="fa fa-plus" aria-hidden="true"></i></p> -->
                                    <p>
                                        Agregar información de entrega
                                        <i class="ms-2 fa fa-plus" aria-hidden="true"></i>
                                    </p>
                                </a>
                            </div>
                        </div>

                        <div ref="addDataForm">
                            <div v-if="add_delivery_data && !edit_delivery_data && personal_data && personal_data.length < 3" class="form-cart mb-3">
                                <div>
                                    <h5 class="mt-3 mb-1">
                                        Detalles del cliente
                                    </h5>
                                    <div class="data-description mb-3">
                                        <p class="data-label fs-6 mb-0">Nombre</p>
                                        <p v-if="user_data && user_data.name" class="data-value fs-6 fw-bolder">{{ user_data.name }}</p>
                                        <p v-else class="data-value fs-6 fw-bolder">No aplica</p>
                                    </div>
                                    <div class="data-description mb-3">
                                        <p class="data-label fs-6 mb-0">Número de documento</p>
                                        <p v-if="user_data && user_data.identification_number" class="data-value fs-6 fw-bolder">{{ user_data.identification_number }}</p>
                                        <p v-else class="data-value fs-6 fw-bolder">No aplica</p>
                                    </div>
                                </div>
                                <div>
                                    <h5 class="mt-3 mb-1">
                                        Para agregar una nueva dirección
                                    </h5>
                                    <div class="data-description mb-3">
                                        <p class="data-label fs-6 mb-0">Confirma los siguientes datos</p>
                                    </div>
                                </div>
                                <form @submit.prevent="storeDeliveryData" class="d-flex flex-column">

                                    <input v-model="state_id" name="state_id_nc" type="hidden"  />
                                    <input v-model="state_name" name="state_name_nc" type="hidden"  />
                                    <input v-model="city_id" name="city_id_nc" type="hidden"  />
                                    <input v-model="city_name" name="city_name_nc" type="hidden"  />

                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="email" style="width:13%;" id="label-1">E-mail</label>
                                            <input v-model="email" type="text" name="email">
                                            <span v-if="errors_personal_data && errors_personal_data.email" class="error text-danger" for="image">{{ errors_personal_data.email[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="" style="width:17%" id="label-3">Departamento</label>
                                            <select v-model="state">
                                                <option v-for="state in states" :value="state">{{ state.name }}</option>
                                            </select>
                                            <span v-if="errors_personal_data && errors_personal_data.state_id_nc" class="error text-danger" for="image">{{ errors_personal_data.state_id_nc[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="" style="width:10%" id="label-4">Ciudad</label>
                                            <select v-model="city">
                                                <option v-for="city in cities" :value="city">{{ city.name_city }}</option>
                                            </select>
                                            <span v-if="errors_personal_data && errors_personal_data.city_id_nc" class="error text-danger" for="image">{{ errors_personal_data.city_id_nc[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="" style="width:14%" id="label-5">Dirección</label>
                                            <input v-model="address" type="text" name="">
                                            <span v-if="errors_personal_data && errors_personal_data.address" class="error text-danger" for="image">{{ errors_personal_data.address[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="mobile_number" style="width:10%" id="label-2">Celular</label>
                                            <input v-model="mobile_number" type="text" name="mobile_number">
                                            <span v-if="errors_personal_data && errors_personal_data.mobile_number" class="error text-danger" for="image">{{ errors_personal_data.mobile_number[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="additional_info" style="width:30%" id="label-8">Instrucciones de entrega</label>
                                            <input type="text" v-model="delivery_instructions" name="additional_info" placeholder="apartamento, torre, piso, etc...">
                                            <span v-if="errors_personal_data && errors_personal_data.delivery_instructions" class="error text-danger" for="image">{{ errors_personal_data.delivery_instructions[0] }}</span>
                                        </div>
                                    </div>
                                    <div v-if="personal_data && personal_data.length > 0" class="check-form-cart d-flex align-items-start">
                                        <input v-model="is_default_option" type="checkbox" name="is_default_option">
                                        <span class="ps-1">Establecer información de entrega como predeterminada.</span>
                                    </div>

                                    <div class="row mt-3">
                                        <div class="col-12 next-button">
                                            <button class="btnBlue text-title-bat" style="width: 100%;">Guardar</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div v-else-if="add_delivery_data && edit_delivery_data && selected_delivery_data !== null" class="form-cart mb-3">
                                <form @submit.prevent="updateDeliveryData" class="d-flex flex-column">
                                    <input v-model="personal_data_to_edit.id" name="id" type="hidden"  />
                                    <input v-model="state_id" name="state_id_nc" type="hidden"  />
                                    <input v-model="state_name" name="state_name_nc" type="hidden"  />
                                    <input v-model="city_id" name="city_id_nc" type="hidden"  />
                                    <input v-model="city_name" name="city_name_nc" type="hidden"  />

                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="" style="width:17%" id="label-3">Departamento</label>
                                            <select v-model="state">
                                                <option v-for="state in states" :value="state">{{ state.name }}</option>
                                            </select>
                                            <span v-if="errors_personal_data && errors_personal_data.state_id_nc" class="error text-danger" for="image">{{ errors_personal_data.state_id_nc[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="" style="width:10%" id="label-4">Ciudad</label>
                                            <select v-model="city">
                                                <option v-for="city in cities" :value="city">{{ city.name_city }}</option>
                                            </select>
                                            <span v-if="errors_personal_data && errors_personal_data.city_id_nc" class="error text-danger" for="image">{{ errors_personal_data.city_id_nc[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="" style="width:14%" id="label-5">Dirección</label>
                                            <input v-model="address" type="text" name="">
                                            <span v-if="errors_personal_data && errors_personal_data.address" class="error text-danger" for="image">{{ errors_personal_data.address[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="email" style="width:10%;" id="label-1">E-mail</label>
                                            <input v-model="email" type="text" name="email">
                                            <span v-if="errors_personal_data && errors_personal_data.email" class="error text-danger" for="image">{{ errors_personal_data.email[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column">
                                            <label for="mobile_number" style="width:10%" id="label-2">Celular</label>
                                            <input v-model="mobile_number" type="text" name="mobile_number">
                                            <span v-if="errors_personal_data && errors_personal_data.mobile_number" class="error text-danger" for="image">{{ errors_personal_data.mobile_number[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-12 d-flex flex-column form-div-cart">
                                            <label for="additional_info" style="width:30%" id="label-8">Instrucciones de entrega</label>
                                            <input type="text" v-model="delivery_instructions" name="additional_info" placeholder="apartamento, torre, piso, etc...">
                                            <span v-if="errors_personal_data && errors_personal_data.delivery_instructions" class="error text-danger" for="image">{{ errors_personal_data.delivery_instructions[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="check-form-cart d-flex align-items-start">
                                        <input v-if="is_default_option == true && personal_data_to_edit.is_default_option == 1" v-model="is_default_option" type="checkbox" name="is_default_option" disabled>
                                        <input v-else v-model="is_default_option" type="checkbox" name="is_default_option">
                                        <span class="ps-1">Establecer información de entrega como predeterminada.</span>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-12 next-button">
                                            <!-- <button @click="updateDeliveryData()" class="btnBlue" style="width: 100%;">Actualizar</button> -->
                                            <button class="btnBlue text-title-bat" style="width: 100%;">Actualizar</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div v-else-if="add_delivery_data &&  !edit_delivery_data && personal_data && personal_data.length == 3" class="msj-error mt-4">
                                <div class="content d-flex align-items-start p-2">
                                    <p class="mb-0" style="font-size: 14px;"> Alcanzaste el tope de datos de envío. Puedes usar los que ya creaste o actualizarlos dando clic en "Editar".</p>
                                </div>
                            </div>
                            <div v-else-if="!add_delivery_data && !edit_delivery_data && personal_data && personal_data.length > 0" class="selected-delivery-data">
                                <div v-if="successfully_created_message && !successfully_updated_message && !successfully_deleted_message" class="msj-success mt-4">
                                    <div class="content d-flex align-items-start p-2">
                                        <p class="mb-0" style="font-size: 14px;"> Información de entrega <strong>creada</strong> exitosamente!.</p>
                                    </div>
                                </div>
                                <div v-if="!successfully_created_message && successfully_updated_message && !successfully_deleted_message" class="msj-success mt-4">
                                    <div class="content d-flex align-items-start p-2">
                                        <p class="mb-0" style="font-size: 14px;"> Información de entrega <strong>actualizada</strong> exitosamente!.</p>
                                    </div>
                                </div>
                                <div v-if="!successfully_created_message && !successfully_updated_message && successfully_deleted_message" class="msj-success mt-4">
                                    <div class="content d-flex align-items-start p-2">
                                        <p class="mb-0" style="font-size: 14px;"> Información de entrega <strong>eliminada</strong> exitosamente!.</p>
                                    </div>
                                </div>
                                <div class="header my-3">
                                    <h6 class="title">Información de Entrega</h6>
                                    <p class="subtitle">Confirma los siguientes datos.</p>
                                </div>
                                <div class="data-description mb-3">
                                    <p class="data-label">Nombre</p>
                                    <p v-if="user_data && user_data.name" class="data-value">{{ user_data.name }}</p>
                                    <p v-else class="data-value">No aplica</p>
                                </div>
                                <div class="data-description mb-3">
                                    <p class="data-label">Número de documento</p>
                                    <p v-if="user_data && user_data.identification_number" class="data-value">{{ user_data.identification_number }}</p>
                                    <p v-else class="data-value">No aplica</p>
                                </div>
                                <div class="data-description mb-3">
                                    <p class="data-label">Dirección</p>
                                    <p v-if="selected_delivery_data" class="data-value">{{ selected_delivery_data.address }}, {{ selected_delivery_data.city_name_nc }} ({{ selected_delivery_data.state_name_nc }})</p>
                                    <p v-else class="data-value">No aplica</p>
                                </div>
                                <div class="data-description mb-3">
                                    <p class="data-label">Email</p>
                                    <p v-if="selected_delivery_data" class="data-value">{{ selected_delivery_data.email }}</p>
                                    <p v-else class="data-value">No aplica</p>
                                </div>
                                <div class="data-description mb-3">
                                    <p class="data-label">Celular</p>
                                    <p v-if="selected_delivery_data" class="data-value">{{ formatMobileNumber(selected_delivery_data.mobile_number) }}</p>
                                    <p v-else class="data-value">No aplica</p>
                                </div>
                                <div class="data-description mb-3">
                                    <p class="data-label">Instrucciones de entrega</p>
                                    <p v-if="selected_delivery_data" class="data-value">
                                        {{ (selected_delivery_data.delivery_instructions != null && selected_delivery_data.delivery_instructions != '') ? selected_delivery_data.delivery_instructions : 'No aplica' }}
                                    </p>
                                    <p v-else class="data-value">No aplica</p>
                                </div>
                                <div>
                                    <p class="text-black  bg-danger bg-opacity-25 d-flex align-items-center fs-6">
                                        <img class="border-start py-3 px-3 border-5 border-danger me-1" src="/img-version2/icons/red-semaforo.svg" alt="">
                                        Esta es la información de entrega, favor verificar.
                                    </p>
                                </div>
                                <div class="check-delivery-mode d-flex align-items-start mb-3">
                                    <input v-model="check" type="checkbox" name="check">
                                    <span class="ps-1">Soy consciente que los bonos digitales llegan por el correo electrónico o al número celular suministrado en este formulario y los productos físicos a la dirección diligenciada.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-12 col-lg-5">
                    <div class="card-points-cart mx-auto">
                        <div class="header py-3">
                            <h6>Validación Puntos</h6>
                        </div>
                        <div class="descrip-puntos bg-points-dark py-1">
                            <p>Puntos Disponibles</p>
                            <span>{{ numberFormat(points_user) }} puntos</span>
                        </div>
                        <div class="descrip-puntos py-1">
                            <p>Total carrito</p>
                            <span>{{ numberFormat(local_total_points) }} puntos</span>
                        </div>
                        <div class="descrip-puntos bg-points-dark py-1 bg-warning bg-gradient bg-opacity-75">
                            <p><strong>Saldo de puntos</strong></p>
                            <strong>{{ numberFormat(points_user-local_total_points) }} puntos</strong>
                        </div>
                    </div>
                    <div v-if="points_user - local_total_points < 0"
                        style="border-left: 4px solid var(--Semantic-Danger-100, #F00); background: #FFDED9; padding: 10px;"
                        class="mt-3 text-bat">
                        <p class="mb-0"> No tienes los suficientes puntos para redimir estos productos.</p>
                    </div>
                    <div class="card-points-cart mx-auto mt-3"
                        v-if="(monthly_points_limit !== 0 || daily_points_limit !== 0 || current_bonuses_limit !== 0 || current_physics_limit !== 0) && step === 1">
                        <div class="header py-3">
                            <h6>Validación de Topes</h6>
                        </div>
                        <!-- monthly_points_limit: 0,
                        daily_points_limit: 0,
                        current_points_limit: 0,
                        current_bonuses_limit: 0,
                        current_physics_limit: 0, -->
                        <div class="descrip-puntos py-1 bg-gradient bg-opacity-75">
                            <p>Llevas</p>
                            <P>Tope</P>
                        </div>
                        <!-- Bloque para redención mensual -->
                        <div v-if="monthly_points_limit !== 0"
                            :style="{ 'border-left': redemption_total_month > monthly_points_limit ? '3px solid #F00' : '3px solid #83D300', 'margin-bottom': '1rem' }">
                            <div @click="toggleCollapse('monthly')" class="collapse-header">
                                <div class="d-flex align-items-center">
                                    <img :src="redemption_total_month > monthly_points_limit ? '/img-version2/icons/red-stop.svg' : '/img-version2/icons/green-stop.svg'"
                                        alt="">
                                    <strong class="px-2">{{ numberFormat(redemption_total_month) }}</strong>
                                    <p class="text-bat mt-3">Puntos por mes</p>
                                </div>
                                <div class="d-flex">
                                    <strong>{{ numberFormat(monthly_points_limit) }}</strong>
                                    <img :src="isOpenMonthly ? '/img-version2/icons/arrow-down-black.svg' : '/img-version2/icons/arrow-down-black.svg'"
                                        alt="Toggle Image">
                                </div>
                            </div>
                            <div v-show="isOpenMonthly || redemption_total_month > monthly_points_limit"
                                class="collapse-content text-bat"
                                :class="{ 'background-red': redemption_total_month > monthly_points_limit }">
                                <p style="padding: 0 20px; margin: 0;"
                                    v-if="redemption_total_month > monthly_points_limit">{{
                                    over_monthly_points_limit_message }}</p>
                                <p style="padding: 0 20px; margin: 0;" v-else>{{ under_monthly_points_limit_message }}
                                </p>
                            </div>
                        </div>

                        <!-- Bloque para puntos por día -->
                        <div v-if="daily_points_limit !== 0"
                            :style="{ 'border-left': redemption_total_points_per_day > daily_points_limit ? '3px solid #F00' : '3px solid #83D300', 'margin-bottom': '1rem' }">
                            <div @click="toggleCollapse('daily')" class="collapse-header">
                                <div class="d-flex align-items-center">
                                    <img :src="redemption_total_points_per_day > daily_points_limit ? '/img-version2/icons/red-stop.svg' : '/img-version2/icons/green-stop.svg'"
                                        alt="">
                                    <strong class="px-2">{{ numberFormat(redemption_total_points_per_day) }}</strong>
                                    <p class="text-bat mt-3">Puntos por día</p>
                                </div>
                                <div class="d-flex">
                                    <strong>{{ numberFormat(daily_points_limit) }}</strong>
                                    <img :src="isOpenDaily ? '/img-version2/icons/arrow-down-black.svg' : '/img-version2/icons/arrow-down-black.svg'"
                                        alt="Toggle Image">
                                </div>
                            </div>
                            <div v-show="isOpenDaily || redemption_total_points_per_day > daily_points_limit"
                                class="collapse-content text-bat"
                                :class="{ 'background-red': redemption_total_points_per_day > daily_points_limit }">
                                <p style="padding: 0 20px; margin: 0;"
                                    v-if="redemption_total_points_per_day > daily_points_limit">{{
                                    over_daily_points_limit_message
                                    }}</p>
                                <p style="padding: 0 20px; margin: 0;" v-else>{{ under_daily_points_limit_message }}</p>
                            </div>
                        </div>

                        <!-- Bloque para redención diaria -->
                        <div v-if="daily_redemption_limit !== 0"
                            :style="{ 'border-left': redemption_total_day > daily_redemption_limit ? '3px solid #F00' : '3px solid #83D300', 'margin-bottom': '1rem' }">
                            <div @click="toggleCollapse('dailyRedemption')" class="collapse-header">
                                <div class="d-flex align-items-center">
                                    <img :src="redemption_total_day > daily_redemption_limit ? '/img-version2/icons/red-stop.svg' : '/img-version2/icons/green-stop.svg'"
                                        alt="">
                                    <strong class="px-2">{{ numberFormat(redemption_total_day) }}</strong>
                                    <p class="text-bat mt-3">Redenciones por día</p>
                                </div>
                                <div class="d-flex">
                                    <strong>{{ numberFormat(daily_redemption_limit) }}</strong>
                                    <img :src="isOpenDailyRedemption ? '/img-version2/icons/arrow-down-black.svg' : '/img-version2/icons/arrow-down-black.svg'"
                                        alt="Toggle Image">
                                </div>
                            </div>
                            <div v-show="isOpenDailyRedemption || redemption_total_day > daily_redemption_limit"
                                class="collapse-content text-bat"
                                :class="{ 'background-red': redemption_total_day > daily_redemption_limit }">
                                <p style="padding: 0 20px; margin: 0;"
                                    v-if="redemption_total_day > daily_redemption_limit">{{
                                    over_daily_redemption_limit_message
                                    }}</p>
                                <p style="padding: 0 20px; margin: 0;" v-else>{{ under_daily_redemption_limit_message }}
                                </p>
                            </div>
                        </div>

                        <!-- Bloque para Bonos digitales por redención -->
                        <div v-if="current_bonuses_limit !== 0"
                            :style="{ 'border-left': current_total_bonuses > current_bonuses_limit ? '3px solid #F00' : '3px solid #83D300', 'margin-bottom': '1rem' }">
                            <div @click="toggleCollapse('redemptionBonuses')" class="collapse-header">
                                <div class="d-flex align-items-center">
                                    <img :src="current_total_bonuses > current_bonuses_limit ? '/img-version2/icons/red-stop.svg' : '/img-version2/icons/green-stop.svg'"
                                        alt="">
                                    <strong class="px-2">{{ numberFormat(current_total_bonuses) }}</strong>
                                    <p class="text-bat mt-3">Bonos digitales por redención</p>
                                </div>
                                <div class="d-flex">
                                    <strong>{{ numberFormat(current_bonuses_limit) }}</strong>
                                    <img :src="isOpenredemptionBonuses ? '/img-version2/icons/arrow-down-black.svg' : '/img-version2/icons/arrow-down-black.svg'"
                                        alt="Toggle Image">
                                </div>
                            </div>
                            <div v-show="isOpenredemptionBonuses || (current_total_bonuses > current_bonuses_limit)"
                                class="collapse-content text-bat"
                                :class="{ 'background-red': current_total_bonuses > current_bonuses_limit }">
                                <p style="padding: 0 20px; margin: 0;"
                                    v-if="current_total_bonuses > current_bonuses_limit">{{
                                    over_current_bonuses_limit_message }}</p>
                                <p style="padding: 0 20px; margin: 0;" v-else>{{ under_current_bonuses_limit_message }}
                                </p>
                            </div>
                        </div>

                        <!-- Bloque para Producto físico por redención -->
                        <div v-if="current_physics_limit !== 0"
                            :style="{ 'border-left': current_total_physics > current_physics_limit ? '3px solid #F00' : '3px solid #83D300', 'margin-bottom': '1rem' }">
                            <div @click="toggleCollapse('physicalProduct')" class="collapse-header">
                                <div class="d-flex align-items-center">
                                    <img :src="current_total_physics > current_physics_limit ? '/img-version2/icons/red-stop.svg' : '/img-version2/icons/green-stop.svg'"
                                        alt="">
                                    <strong class="px-2">{{ numberFormat(current_total_physics) }}</strong>
                                    <p class="text-bat mt-3">Producto físico por redención</p>
                                </div>
                                <div class="d-flex">
                                    <strong>{{ numberFormat(current_physics_limit) }}</strong>
                                    <img :src="isOpenPhysicalProduct ? '/img-version2/icons/arrow-down-black.svg' : '/img-version2/icons/arrow-down-black.svg'"
                                        alt="Toggle Image">
                                </div>
                            </div>
                            <div v-show="isOpenPhysicalProduct || current_total_physics > current_physics_limit"
                                class="collapse-content text-bat"
                                :class="{ 'background-red': current_total_physics > current_physics_limit }">
                                <p style="padding: 0 20px; margin: 0;"
                                    v-if="current_total_physics > current_physics_limit">{{
                                    over_current_physics_limit_message
                                    }}</p>
                                <p style="padding: 0 20px; margin: 0;" v-else>{{ under_current_physics_limit_message }}
                                </p>
                            </div>
                        </div>

                    </div>
                    <div v-if="total_limits_exceeded > 0 && (monthly_points_limit !== 0 || daily_points_limit !== 0 || current_bonuses_limit !== 0 || current_physics_limit !== 0)"
                        style="border-left: 4px solid var(--Semantic-Danger-100, #F00); background: #FFDED9; padding: 10px;"
                        class="mt-3 text-bat">
                        <p class="mb-0">Superaste {{ total_limits_exceeded }} de los topes asignados, por lo cual, no es
                            posible continuar con tu redención.</p>
                    </div>
                    <div v-if="errors && errors.length > 0" class="card mt-2">
                        <div class="card-body">
                            Los siguientes campos contienen errores o estan vacios
                            <ul>
                                <li v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="check-delivery-mode d-flex align-items-start mb-3" v-if="step === 1 && validateCheckBat()">
                            <input v-model="checkBat" type="checkbox" name="checkBat">
                            <span class="ps-1">Recuerda que al momento de hacer pedido de tus productos, solo podrás redimir un código por compra.</span>
                        </div>
                        <div class="col-12 col-md-6 text-center my-3 order-2 order-md-1 py-md-3 py-0">
                            <a class="text-decoration-none text-title-bat text-indigo cursor-pointer w-100 py-md-3 py-0"
                                v-if="step === 1" href="/catalogo">Cancelar</a>
                            <a v-else class="text-decoration-none text-title-bat text-indigo cursor-pointer w-100"
                                @click.prevent="step = 1">Anterior</a>
                        </div>
                        <div class="col-12 col-md-6  text-center mt-4 mb-3 order-1 order-md-2">
                            <!-- <div v-if="step === 1 && redemption_valid_segment == 1"> -->
                            <div v-if="step === 1">
                                <!-- <button v-if="points_user-local_total_points >= 0 && monthly_points_limit-redemption_total_month-local_total_points < 0 && local_products.length > 0" @click="modal_redemption_limit = true" class="btnBlue w-100 text-title-bat rounded-3">Siguiente</button>
                                <button v-else-if="points_user-local_total_points >= 0 && monthly_points_limit-redemption_total_month-local_total_points >= 0 && local_products.length > 0" @click="step = 2" class="btnBlue w-100 text-title-bat rounded-3">Siguiente</button>
                                <button v-else class="btnBlue w-100 text-title-bat rounded-3 disabled">Siguiente</button> -->

                                <button
                                    v-if="points_user - local_total_points >= 0 && total_limits_exceeded === 0 && local_products.length > 0 && validateBonusWebOrdering()"
                                    @click="step = 2" class="btnBlue w-100 text-title-bat rounded-3">
                                    Siguiente
                                </button>
                                <button v-else @click.prevent class="btnBlue w-100 text-title-bat rounded-3"
                                    :style="{ opacity: total_limits_exceeded !== 0 || validateBonusWebOrdering() === false ? '0.5' : '1', cursor: total_limits_exceeded !== 0 || validateBonusWebOrdering() === false ? 'not-allowed' : 'pointer'}"
                                    :disabled="total_limits_exceeded !== 0 || validateBonusWebOrdering() === false">
                                    Siguiente
                                </button>
                            </div>
                            <div v-else>
                                <button id="boton-redimir" title="redimir" v-if="(points_user-local_total_points >= 0) && local_products.length > 0 && (loading !== 0 || redemption_success === true)" class="bntBlue w-100 text-title-bat rounded-3 ">
                                    <i v-if="loading" class="fa-solid fa-spinner fa-spin-pulse" :class="(add_delivery_data || edit_delivery_data || !selected_delivery_data || !check ) ? 'disabled ' : ''"></i>
                                    Redimir
                                </button>
                                <button id="boton-redimir" title="redimir"
                                    v-else-if="(points_user - local_total_points >= 0) && local_products.length > 0"
                                    @click="completeCart()" class="btnBlue w-100 text-title-bat rounded-3 "
                                    :class="(add_delivery_data || edit_delivery_data || !selected_delivery_data || !check) ? 'btnBlue w-100 text-title-bat rounded-3  disabled' : ''">Redimir</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="modal_delete_product" :width="$mq === 'sm' ? '90%' : $mq === 'xl' ? '25%' : '40%'"
            :close-on-click-modal="false" :close-on-press-escape="false" key="delete_product_modal" :show-close="false">
            <div class="modals">
                <img src="/img-version2/modal/trash.svg" alt="image 8">
                <h6 class="my-3 mx-auto" style="width: auto!important; max-width: 268px!important;">¿Estás seguro que
                    deseas eliminar este producto?</h6>
                <div class="modals d-flex align-items-center flex-column justify-content-center px-0">
                    <div class="row">
                        <div class="col-6" style="padding: 10px 0!important;">
                            <div class="buttonOne" type="buttoNot" @click="modal_delete_product = false">No, volver
                            </div>
                        </div>
                        <div class="col-6" style="padding: 10px 0!important;">
                            <div class="buttonTwo" type="buttoYes" @click="deleteProduct(delete_product_guid)">Sí,
                                eliminar</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modal_redemption_limit" :width="$mq === 'sm' ? '90%' : $mq === 'xl' ? '25%' : '40%'"
            :close-on-click-modal="false" :close-on-press-escape="false" key="redemption_limit_modal"
            :show-close="false">
            <div class="text-center">
                <img src="/img-version2/modal/alert-icon.svg" width="110px" alt="image 8">
                <h6 class="my-3 mx-auto">Tope máximo superado</h6>
                <p>Estás excediendo tu monto de redención máximo en bonos de alimentación para que no aplique retención
                    en la fuente. Este límite sólo aplica para ingresos laborales mensuales inferiores a $13.140.000.
                    Cualquier impuesto que se origine como consecuencia de la redención en bonos de alimentación que
                    exceda el monto máximo estará a cargo del empleado ¿Estás seguro que quieres proceder con la
                    redención?</p>
                <div class="align-items-center flex-column justify-content-center">
                    <div class="row">
                        <div class="col-6">
                            <div class="buttonOne" type="buttoNot" @click="modal_redemption_limit = false">Cancelar
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="buttonTwo" type="buttoYes" @click="step = 2; modal_redemption_limit = false">Si,
                                entendido</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modal_redemption_success" :width="$mq === 'sm' ? '90%' : $mq === 'xl' ? '25%' : '50%'"
            :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" key="redemption_success">
            <div class="modals d-flex align-items-center flex-column justify-content-center text-wrap">
                <img src="/img-version2/modal/tick-circle.svg" alt="image 8">
                <h6 class="my-3">Redención exitosa</h6>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-if="show_redemption_recharge === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_recharge === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_recharge === false"></i>
                        Redención de Recargas
                        <p v-if="redemption_recharge === true">{{ delivery_dates.recharge }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_digitalVoucher === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_digitalVoucher === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_digitalVoucher === false"></i>
                        Redención de Bono Digital
                        <p v-if="redemption_digitalVoucher === true">{{ delivery_dates.digitalVoucher }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_physical === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_physical === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_physical === false"></i>
                        Redención de Productos Físicos
                        <p v-if="redemption_physical === true">{{ delivery_dates.physical }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_daviplata === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_daviplata === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_daviplata === false"></i>
                        Redención de Daviplata
                        <p v-if="redemption_daviplata === true">{{ delivery_dates.daviplata }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_bonoFalabella === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_bonoFalabella === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_bonoFalabella === false"></i>
                        Redención de Bono Falabella
                        <p v-if="redemption_bonoFalabella === true">{{ delivery_dates.bonoFalabella }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_bonoCorbeta === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_bonoCorbeta === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_bonoCorbeta === false"></i>
                        Redención de Bono Corbeta
                        <p v-if="redemption_bonoCorbeta === true">{{ delivery_dates.bonoCorbeta }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_bonoSodexo === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_bonoSodexo === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_bonoSodexo === false"></i>
                        Redención de Bono Sodexo
                        <p v-if="redemption_bonoSodexo === true">{{ delivery_dates.bonoSodexo }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_bonoExito === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_bonoExito === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_bonoExito === false"></i>
                        Redención de Bono Exito
                        <p v-if="redemption_bonoExito === true">{{ delivery_dates.bonoExito }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_bonoMakro === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_bonoMakro === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_bonoMakro === false"></i>
                        Redención de Bono Makro
                        <p v-if="redemption_bonoMakro === true">{{ delivery_dates.bonoMakro }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_bonoWebOrdering === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_bonoWebOrdering === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_bonoWebOrdering === false"></i>
                        Redención de Cupón BAT
                        <p v-if="redemption_bonoWebOrdering === true">{{ delivery_dates.bonoWebOrdering }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_recargaSodexo === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_recargaSodexo === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_recargaSodexo === false"></i>
                        Redención de la Recarga Sodexo
                        <p v-if="redemption_recargaSodexo === true">{{ delivery_dates.recargaSodexo }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_newCardSodexo === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_newCardSodexo === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_newCardSodexo === false"></i>
                        Redención de la nueva tarjeta Sodexo
                        <p v-if="redemption_newCardSodexo === true">{{ delivery_dates.newCardSodexo }}</p>
                        <hr class="mt-2">
                    </li>
                    <li class="list-group-item" v-if="show_redemption_reissueCardSodexo === true">
                        <i class="fa-solid fa-circle-check" v-if="redemption_reissueCardSodexo === true"></i>
                        <i class="fa-solid fa-xmark" v-if="redemption_reissueCardSodexo === false"></i>
                        Redención de la reexpiración tarjeta Sodexo
                        <p v-if="redemption_reissueCardSodexo === true">{{ delivery_dates.reissueCardSodexo }}</p>
                        <hr class="mt-2">
                    </li>
                </ul>

                <div class="moldals col-12 mt-4 pt-4">
                    <div class="buttonAccept mx-auto" @click="cartSuccess()">Aceptar</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { clippingParents } from '@popperjs/core';

export default {
    props: {
        products: {
            default: [],
        },
        redemption_status: {
            default: [],
        },
        url_media: {
            default: null,
        },
        points_user: {
            default: 0,
        },
        total_points: {
            default: 0,
        },
        type_recharge: {
            default: 3,
        },
        type_physic: {
            default: 2,
        },
        customer_id: {
            default: null,
        },
        segmentation_id: {
            default: null,
        },
        program_id: {
            default: 0,
        }
    },
    data() {
        return {
            loading: 0,
            step: 1,
            states: null,
            cities: null,
            local_total_points: 0,
            redemption_success: false,
            redemption_digitalVoucher: false,
            redemption_physical: false,
            redemption_recharge: false,
            redemption_daviplata: false,
            redemption_bonoFalabella: false,
            redemption_bonoCorbeta: false,
            redemption_bonoSodexo: false,
            redemption_bonoExito: false,
            redemption_bonoMakro: false,
            redemption_bonoWebOrdering: false,
            redemption_recargaSodexo: false,
            redemption_newCardSodexo: false,
            redemption_reissueCardSodexo: false,
            show_redemption_digitalVoucher: false,
            show_redemption_physical: false,
            show_redemption_recharge: false,
            show_redemption_daviplata: false,
            show_redemption_bonoFalabella: false,
            show_redemption_bonoCorbeta: false,
            show_redemption_bonoSodexo: false,
            show_redemption_bonoExito: false,
            show_redemption_bonoMakro: false,
            show_redemption_bonoWebOrdering: false,
            show_redemption_recargaSodexo: false,
            show_redemption_newCardSodexo: false,
            show_redemption_reissueCardSodexo: false,
            local_products: [],
            errors: [],

            name: '',
            label_personal_data: '',
            email: '',
            mobile_number: '',

            state: null,
            state_id: '',
            state_name: '',

            city: null,
            city_id: '',
            city_name: '',

            address: '',
            delivery_instructions: '',
            is_default_option: false,
            errors_personal_data: [],
            personal_data: [],
            personal_data_default: null,
            user_data: null,
            check: false,
            has_recharge: false,
            has_physic: false,
            mobile_operator: null,
            modal_delete_product: false,
            modal_redemption_success: false,
            modal_redemption_limit: false,
            delete_product_guid: 0,
            guid_cart: '',
            products_data: [],
            delivery_dates: [],

            add_delivery_data: false,
            edit_delivery_data: false,
            selected_delivery_data: null,
            personal_data_to_edit: null,

            successfully_created_message: false,
            successfully_updated_message: false,
            successfully_deleted_message: false,

            monthly_points_limit: 0,
            daily_points_limit: 0,
            daily_redemption_limit: 0,
            current_bonuses_limit: 0,
            current_physics_limit: 0,

            over_monthly_points_limit_message: '',
            over_daily_points_limit_message: '',
            over_daily_redemption_limit_message: '',
            over_current_bonuses_limit_message: '',
            over_current_physics_limit_message: '',

            under_monthly_points_limit_message: '',
            under_daily_points_limit_message: '',
            under_daily_redemption_limit_message: '',
            under_current_bonuses_limit_message: '',
            under_current_physics_limit_message: '',

            redemption_total_month: 0,
            redemption_total_day: 0,
            isOpenMonthly: false,
            isOpenDaily: false,
            isOpenPhysicalProduct: false,
            isOpenredemptionBonuses: false,
            isOpenDailyRedemption: false,
            // countLimitsExceeded: 0,
            redemption_total_points_per_day: 0,
            current_total_bonuses: 0,
            current_total_physics: 0,

            total_limits_exceeded: 0,
            checkBat: false,
        }
    },
    mounted () {
        this.local_total_points = this.total_points
        this.local_products = this.products
        this.getStates()
        for(var product of this.products){
            if(product.PRODUCT_TYPE_ID === this.type_recharge){
                this.has_recharge = true
                this.mobile_operator = product.OPERATOR
            }
            if(product.PRODUCT_TYPE_ID !== this.type_recharge){
                this.has_physic = true
            }
        }
        this.personal_data = this.getRedemptionPersonalData(this.customer_id)
        this.getRedemptionLimitsInfo()
        setTimeout(() => {
            this.$notify.close();
        }, 8000);
    },
    watch: {
        state: function() {
            if(this.state) {
                this.state_id=this.state.id_departments
                this.state_name=this.state.name

                this.city = null
                this.getCities()
                if(this.edit_delivery_data) {
                    this.city = {
                        id_city: this.personal_data_to_edit.city_id_nc,
                        id_departments: this.personal_data_to_edit.state_id_nc,
                        name_city: this.personal_data_to_edit.city_name_nc
                    }
                }
            } else {
                this.state_id=''
                this.state_name=''
            }
        },
        city: function() {
            if(this.city) {
                this.city_id=this.city.id_city
                this.city_name=this.city.name_city
            } else {
                this.city_id=''
                this.city_name=''
            }
        },
        personal_data: function() {
            if(this.personal_data && this.personal_data.length == 1 && this.personal_data[0].is_default_option == 0) {
                this.personal_data[0].is_default_option = 1
                this.selected_delivery_data = this.personal_data[0]
            }
            this.add_delivery_data = false
            this.edit_delivery_data = false
        },
    },
    methods: {
        numberFormat(number) {
            const exp = /(\d)(?=(\d{3})+(?!\d))/g
            const rep = '$1,'
            let arr = number.toString().split('.')
            arr[0] = arr[0].replace(exp,rep)
            return arr[1] ? arr.join('.'): arr[0]
        },
        getRedemptionLimitsInfo() {
            this.monthly_points_limit = this.redemption_status.redemption_limit[0]["value"] ? this.redemption_status.redemption_limit[0]["value"] : 0
            this.daily_points_limit = this.redemption_status.redemption_limit[1]["value"] ? this.redemption_status.redemption_limit[1]["value"] : 0
            this.daily_redemption_limit = this.redemption_status.redemption_limit[2]["value"] ? this.redemption_status.redemption_limit[2]["value"] : 0
            this.current_bonuses_limit = this.redemption_status.redemption_limit[3]["value"] ? this.redemption_status.redemption_limit[3]["value"] : 0
            this.current_physics_limit = this.redemption_status.redemption_limit[4]["value"] ? this.redemption_status.redemption_limit[4]["value"] : 0

            this.over_monthly_points_limit_message = this.redemption_status.redemption_limit[0]["over_limit_message"] ? this.redemption_status.redemption_limit[0]["over_limit_message"] : ''
            this.over_daily_points_limit_message = this.redemption_status.redemption_limit[1]["over_limit_message"] ? this.redemption_status.redemption_limit[1]["over_limit_message"] : ''
            this.over_daily_redemption_limit_message = this.redemption_status.redemption_limit[2]["over_limit_message"] ? this.redemption_status.redemption_limit[2]["over_limit_message"] : ''
            this.over_current_bonuses_limit_message = this.redemption_status.redemption_limit[3]["over_limit_message"] ? this.redemption_status.redemption_limit[3]["over_limit_message"] : ''
            this.over_current_physics_limit_message = this.redemption_status.redemption_limit[4]["over_limit_message"] ? this.redemption_status.redemption_limit[4]["over_limit_message"] : ''

            this.under_monthly_points_limit_message = this.redemption_status.redemption_limit[0]["under_limit_message"] ? this.redemption_status.redemption_limit[0]["under_limit_message"] : ''
            this.under_daily_points_limit_message = this.redemption_status.redemption_limit[1]["under_limit_message"] ? this.redemption_status.redemption_limit[1]["under_limit_message"] : ''
            this.under_daily_redemption_limit_message = this.redemption_status.redemption_limit[2]["under_limit_message"] ? this.redemption_status.redemption_limit[2]["under_limit_message"] : ''
            this.under_current_bonuses_limit_message = this.redemption_status.redemption_limit[3]["under_limit_message"] ? this.redemption_status.redemption_limit[3]["under_limit_message"] : ''
            this.under_current_physics_limit_message = this.redemption_status.redemption_limit[4]["under_limit_message"] ? this.redemption_status.redemption_limit[4]["under_limit_message"] : ''

            this.redemption_total_month = this.redemption_status.redemption_total_month ? this.redemption_status.redemption_total_month + this.local_total_points : this.local_total_points
            this.redemption_total_day = this.redemption_status.redemption_total_day ? this.redemption_status.redemption_total_day + 1 : 1
            this.redemption_total_points_per_day = this.redemption_status.redemption_total_points_per_day ? this.redemption_status.redemption_total_points_per_day + this.local_total_points : this.local_total_points


            this.current_total_bonuses = this.products
                .filter(product => [1, 10].includes(product.PRODUCT_TYPE_ID))
                .reduce((accumulator, product) => accumulator + product.QUANTITY, 0);

            this.current_total_physics = this.products
                .filter(product => product.PRODUCT_TYPE_ID === 2)
                .reduce((accumulator, product) => accumulator + product.QUANTITY, 0);

            this.total_limits_exceeded = 0
            this.total_limits_exceeded = (this.monthly_points_limit !== 0 && this.monthly_points_limit < this.redemption_total_month) ? this.total_limits_exceeded + 1 : this.total_limits_exceeded
            this.total_limits_exceeded = (this.daily_points_limit !== 0 && this.daily_points_limit < this.redemption_total_points_per_day) ? this.total_limits_exceeded + 1 : this.total_limits_exceeded
            this.total_limits_exceeded = (this.daily_redemption_limit !== 0 && this.daily_redemption_limit < this.redemption_total_day) ? this.total_limits_exceeded + 1 : this.total_limits_exceeded
            this.total_limits_exceeded = (this.current_bonuses_limit !== 0 && this.current_bonuses_limit < this.current_total_bonuses) ? this.total_limits_exceeded + 1 : this.total_limits_exceeded
            this.total_limits_exceeded = (this.current_physics_limit !== 0 && this.current_physics_limit < this.current_total_physics) ? this.total_limits_exceeded + 1 : this.total_limits_exceeded

    },
        getStates() {
            this.loading++
            axios.get(`/list-department`)
                 .then(({data}) => {
                     this.city_id = ''
                     this.states = data.data
                     this.loading--
                 })
        },
        getCities(){
            this.loading++
            axios.get(`list-city/${this.state_id}`)
                 .then(({data}) => {
                     this.cities = data.data
                     this.loading--
                 })
        },
        deleteProduct(product_guid){
            var dataSend = {
                "guid": product_guid,
            }
            axios.post('/delete-product-shopping-cart', dataSend).then(
                ({data}) => {
                    this.local_products = data.products
                    this.local_total_points = data.total_points
                    this.$emit('products-cart', data.products)
                    this.modal_delete_product = false
                    this.delete_product_guid = 0
                    this.products = data.products;
                    this.getRedemptionLimitsInfo();
                })
        },
        completeCart(){
            this.loading++
            this.parseProducts()
            this.guid_cart = this.createGuid()
            var isProductTypeFisico = this.has_physic
            var isRecharge = this.has_recharge
            var cityIdUser = this.selected_delivery_data.city_id_nc
            var data_form = {
                "name": this.user_data.name,
                "email": this.selected_delivery_data.email,
                "PhoneNumber": this.selected_delivery_data.mobile_number,
                "state_id": this.selected_delivery_data.state_id_nc,
                "city_id": this.selected_delivery_data.city_id_nc,
                "address": this.selected_delivery_data.address,
                "postal_code": this.postal_code,
                "AditionalInformation": this.selected_delivery_data.delivery_instructions,
            }
            var dataSend = {
                "ProgramId": this.program_id,
                "CustomerId": this.customer_id,
                "ShippingInformation": {
                    // "Guid": "sample string 1",
                    "CustomerId": this.customer_id,
                    "Address": this.selected_delivery_data.address,
                    "CityId": this.selected_delivery_data.city_id_nc,
                    "PhoneNumber": this.selected_delivery_data.mobile_number,
                    "OptionalPhoneNumber": null,
                    "Email": this.selected_delivery_data.email,
                    "AditionalInformation": this.selected_delivery_data.delivery_instructions,
                    "MobileOperator": this.mobile_operator ?? null,
                    "MobileNumber": this.selected_delivery_data.mobile_number,
                    "Active": true,
                    "IsNew": true
                },
                "OrderSource": "BAT Web",
                "Cart": this.products_data,
                "ExtendedProperties": [
                    {
                        /*"Guid": this.guid_cart,*/
                        "Name": "Redención",
                        "DisplayName": this.has_recharge ? this.mobile_operator : "Redención",
                        "ValueX": isRecharge ? this.selected_delivery_data.mobile_number : "Conecta2",
                        "Format": "conecta2",
                        "OrderGuid": ""
                    },
                    {
                        "Name": "Segmento",
                        "DisplayName": "Segmento",
                        "ValueX": `${this.segmentation_id}`,
                        "Format": "integer",
                        "OrderGuid": ""
                    }
                ]
            };
            var parseData = {
                "data_form": data_form,
                "arguments": dataSend,
                "total_points": this.local_total_points,
                "is_redeem_now": true
            }

            axios.post('/redeem-shopping-cart', parseData).then(
                ({data}) => {
                    if(data.message != "Success")
                    {
                        this.$notify({
                                         title: 'Error',
                                         message: "Disculpa no fue posible realizar la redención!",
                                         type: 'error',
                                         showClose: true,
                                         duration: 0
                                     });
                    } else {
                        this.redemption_success = true
                        this.modal_redemption_success = true
                        this.redemption_digitalVoucher =  data.data.process.digitalVoucher
                        this.redemption_physical =  data.data.process.physical
                        this.redemption_recharge =  data.data.process.recharge
                        this.redemption_daviplata =  data.data.process.daviplata
                        this.redemption_bonoFalabella =  data.data.process.bonoFalabella
                        this.redemption_bonoCorbeta =  data.data.process.bonoCorbeta
                        this.redemption_bonoSodexo =  data.data.process.bonoSodexo
                        this.redemption_bonoExito =  data.data.process.bonoExito
                        this.redemption_bonoMakro =  data.data.process.bonoMakro
                        this.redemption_bonoWebOrdering =  data.data.process.bonoWebOrdering
                        this.redemption_recargaSodexo =  data.data.process.recargaSodexo
                        this.redemption_newCardSodexo =  data.data.process.newCardSodexo
                        this.redemption_reissueCardSodexo =  data.data.process.reissueCardSodexo
                        this.show_redemption_digitalVoucher =  data.data.show.digitalVoucher
                        this.show_redemption_physical =  data.data.show.physical
                        this.show_redemption_recharge =  data.data.show.recharge
                        this.show_redemption_daviplata =  data.data.show.daviplata
                        this.show_redemption_bonoFalabella =  data.data.show.bonoFalabella
                        this.show_redemption_bonoCorbeta =  data.data.show.bonoCorbeta
                        this.show_redemption_bonoSodexo =  data.data.show.bonoSodexo
                        this.show_redemption_bonoExito =  data.data.show.bonoExito
                        this.show_redemption_bonoMakro =  data.data.show.bonoMakro
                        this.show_redemption_bonoWebOrdering =  data.data.show.bonoWebOrdering
                        this.show_redemption_recargaSodexo =  data.data.show.recargaSodexo
                        this.show_redemption_newCardSodexo =  data.data.show.newCardSodexo
                        this.show_redemption_reissueCardSodexo =  data.data.show.reissueCardSodexo
                        this.delivery_dates = data.data.delivery_dates
                    }
                }).catch(
                function(error) {
                    this.products_data = []
                    if (error.response && error.response.status === 400) {
                        this.$notify({
                                         title: 'Error',
                                         message: error.response.data.message,
                                         type: 'error',
                                         showClose: true,
                                         duration: 0
                                     });
                    }
                }.bind(this)
            ).finally(() => {
                this.loading--
            })
        },
        createGuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        parseProducts() {
            this.products_data = [];
            for(var product of this.local_products){
                var productCurrent = {
                    "Guid": product.GUID,
                    "ReferenceGuid": product.REFERENCE_GUID,
                    "ProducTypeId": product.PRODUCT_TYPE_ID,
                    "Quantity": product.QUANTITY,
                    "CustomerId": product.CUSTOMER_ID,
                    "ProgramId": product.PROGRAM_ID,
                    "PointsUnitValue": product.POINTS_UNIT_VALUE,
                    "MoneyUnitValue": product.MONEY_UNIT_VALUE,
                    "PointsUnitShipping": product.POINTS_UNIT_SHIPPING,
                    "MoneyUnitShipping": product.MONEY_UNIT_SHIPPING,
                    "TaxPercent": product.TAX_PERCENT,
                    "PointsPercent": product.POINTS_PERCENT,
                    "Sendable": product.SENDABLE,
                    "RegisterDate": product.REGISTER_DATE,
                    "Operator": product.OPERATOR,
                }
                this.products_data.push(productCurrent)
            }
        },
        cartSuccess() {
            if (!this.notificationShown) {
                this.feedbackNotification('¡Hay novedades en tu bandeja!', 'Consulta tus notificaciones para más información.', 'info', null);
                this.notificationShown = true;
            }

            setTimeout(() => {
                if (this.loading === 0) {
                    this.loading++;
                    window.location.href = "/catalogo";
                }
            }, 2000);
        },
        feedbackNotification(title, message, type, timer) {
            this.$notify({
                title: title,
                message: message,
                type: type,
                duration: timer
            });
        },
        changeQuantity(index, action){
            if(action === 'remove' && this.local_products[index].QUANTITY > 1){
                this.local_products[index].QUANTITY--
                this.local_total_points = this.local_total_points-(this.local_products[index].POINTS_UNIT_VALUE + this.local_products[index].POINTS_UNIT_SHIPPING)
            }else if(action === 'add' && this.local_products[index].QUANTITY < this.local_products[index].INVENTORY){
                this.local_products[index].QUANTITY++
                this.local_total_points = this.local_total_points+(this.local_products[index].POINTS_UNIT_VALUE + this.local_products[index].POINTS_UNIT_SHIPPING)
            }

            this.getRedemptionLimitsInfo()
        },
        addDeliveryData() {
            if(this.add_delivery_data == false) {
                this.add_delivery_data = true
                this.edit_delivery_data = false
                this.$refs.addDataForm.scrollIntoView({ behavior: 'smooth' });
            } else {
                this.edit_delivery_data = false
                this.$refs.addDataForm.scrollIntoView({ behavior: 'smooth' });
            }

            this.email = ''
            this.mobile_number = ''
            this.state = null
            this.state_id = ''
            this.state_name = ''
            this.city = null
            this.city_id = ''
            this.city_name = ''
            this.address = ''
            this.delivery_instructions = ''
            this.is_default_option = false

            this.check = false
        },
        storeDeliveryData() {
            if(this.personal_data && this.personal_data.length == 0) {
                this.is_default_option = true
            }

            let dataSend = {
                'client_id': this.customer_id,
                'label_personal_data': this.label_personal_data,
                'email': this.email,
                'mobile_number': this.mobile_number,
                'state_id_nc': this.state_id,
                'state_name_nc': this.state_name,
                'city_id_nc': this.city_id,
                'city_name_nc': this.city_name,
                'address': this.address,
                'delivery_instructions': this.delivery_instructions,
                'is_default_option': this.is_default_option,
            }

            let url = ''
            axios.post('/personal-data', dataSend).then(
                (response) => {
                    this.getRedemptionPersonalData(this.customer_id)
                    this.personal_data_default = response.data.personal_data_default;
                    this.add_delivery_data = false
                    this.edit_delivery_data = false

                    this.successfully_created_message = true
                    this.successfully_updated_message = false
                    this.successfully_deleted_message = false

                    this.check = false

                    this.errors_personal_data = null
                }).catch(
                (error) => {
                    if(error && error.response && error.response.data && error.response.data.errors) {
                        console.log(error.response.data.errors)
                        this.errors_personal_data = error.response.data.errors
                    }
                })
        },
        editDeliveryData(item, index) {
            this.$refs.addDataForm.scrollIntoView({ behavior: 'smooth' });
            this.personal_data_to_edit = item

            this.add_delivery_data = true
            this.edit_delivery_data = true

            this.email = item.email
            this.mobile_number = item.mobile_number
            this.state = {
                id_country: 1,
                id_departments: item.state_id_nc,
                name: item.state_name_nc
            }
            // this.city: Se define en el watch de state
            this.address = item.address
            this.delivery_instructions = item.delivery_instructions

            if(this.personal_data_default.id == item.id) {
                this.is_default_option = true
            } else {
                this.is_default_option = false
            }

            this.check = false

        },
        updateDeliveryData(){
            let dataSend = {
                'id': this.personal_data_to_edit.id,
                'client_id': this.customer_id,
                'label_personal_data': this.label_personal_data,
                'email': this.email,
                'mobile_number': this.mobile_number,
                'state_id_nc': this.state_id,
                'state_name_nc': this.state_name,
                'city_id_nc': this.city_id,
                'city_name_nc': this.city_name,
                'address': this.address,
                'delivery_instructions': this.delivery_instructions,
                'is_default_option': this.is_default_option,
            }

            let url = ''
            axios.put(`/personal-data-update/${this.personal_data_to_edit.id}`, dataSend).then(
                (response) => {
                    this.getRedemptionPersonalData(this.customer_id)
                    this.personal_data_default = response.data.personal_data_default;
                    this.add_delivery_data = false
                    this.edit_delivery_data = false

                    this.successfully_created_message = false
                    this.successfully_updated_message = true
                    this.successfully_deleted_message = false

                    this.check = false

                    this.errors_personal_data = null
                }).catch(
                (error) => {
                    if(error && error.response && error.response.data && error.response.data.errors) {
                        console.log(error.response.data.errors)
                        this.errors_personal_data = error.response.data.errors
                    }
                })
        },
        deleteDeliveryData(item, index) {

            axios.delete(`/personal-data-delete/${item.id}`).then(
                (response) => {
                    this.getRedemptionPersonalData(this.customer_id)
                    this.personal_data_default = response.data.personal_data_default;
                    this.add_delivery_data = false
                    this.edit_delivery_data = false

                    this.successfully_created_message = false
                    this.successfully_updated_message = false
                    this.successfully_deleted_message = true

                    this.check = false

                    this.errors_personal_data = null
                }).catch(
                (error) => {
                    if(error && error.response && error.response.data && error.response.data.errors) {
                        console.log(error.response.data.errors)
                        this.errors_personal_data = error.response.data.errors
                    }
                })
        },
        getRedemptionPersonalData(client_id) {
            axios.get(`/personal-data/${client_id}`)
            .then(response => {
                this.personal_data = response.data.personal_data;
                this.selected_delivery_data = response.data.personal_data_default;
                this.personal_data_default = response.data.personal_data_default;
                this.user_data = response.data.user_data;
            })
            .catch(e => {
                //
            })
        },
        changeDeliveryData(id) {
            this.$refs.addDataForm.scrollIntoView({ behavior: 'smooth' });
            let new_selection_delivery_data;
            this.personal_data.forEach(function(element) {
                if(element.id !== id) {
                    element.is_default_option = 0
                } else {
                    element.is_default_option = 1
                    new_selection_delivery_data = element
                }
            }, new_selection_delivery_data);

            this.selected_delivery_data = new_selection_delivery_data
            this.add_delivery_data = false
            this.edit_delivery_data = false

            this.successfully_created_message = false
            this.successfully_updated_message = false
            this.successfully_deleted_message = false

            this.check = false
        },
        capitalizeFLetter(string) {
            string.toLowerCase()
            string[0].toUpperCase()
            return string
        },
        formatMobileNumber(mobile_number) {
            let formatted_mobile_number;
            formatted_mobile_number = mobile_number.slice(0, 3) + ' ' + mobile_number.slice(3, 6) + ' ' + mobile_number.slice(6);
            return formatted_mobile_number;
        },
        returnBack() {
            const urlAnterior = document.referrer;
            if (urlAnterior.includes("/catalog-category/")) {
               window.history.back();
            } else {
                window.location.href = '/catalogo';
            }
        },
        toggleCollapse(type) {
            switch (type) {
                case 'monthly':
                    this.isOpenMonthly = !this.isOpenMonthly;
                    break;
                case 'daily':
                    this.isOpenDaily = !this.isOpenDaily;
                    break;
                case 'physicalProduct':
                    this.isOpenPhysicalProduct = !this.isOpenPhysicalProduct;
                    break;
                case 'redemptionBonuses':
                    this.isOpenredemptionBonuses = !this.isOpenredemptionBonuses;
                    break;
                case 'dailyRedemption':
                    this.isOpenDailyRedemption = !this.isOpenDailyRedemption;
                    break;
                default:
                    break;
            }
        },
        validateCheckBat(){
            let data = this.local_products.map(product => ({
                Guid: product.GUID,
                ReferenceGuid: product.REFERENCE_GUID,
                ProducTypeId: product.PRODUCT_TYPE_ID,
                Quantity: product.QUANTITY,
                CustomerId: product.CUSTOMER_ID,
                ProgramId: product.PROGRAM_ID,
                PointsUnitValue: product.POINTS_UNIT_VALUE,
                MoneyUnitValue: product.MONEY_UNIT_VALUE,
                PointsUnitShipping: product.POINTS_UNIT_SHIPPING,
                MoneyUnitShipping: product.MONEY_UNIT_SHIPPING,
                TaxPercent: product.TAX_PERCENT,
                PointsPercent: product.POINTS_PERCENT,
                Sendable: product.SENDABLE,
                RegisterDate: product.REGISTER_DATE,
                Operator: product.OPERATOR,
            }));

            return data.some(obj => obj.ProducTypeId === 10);
        },
        validateBonusWebOrdering(){
            const validate = this.validateCheckBat();
            if(validate){
                if(!this.checkBat){
                    return false;
                }
            }
            return true;
        },
    },
}
</script>
